/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Countmore1001Inputs */

const en_common_countmore1001 = /** @type {(inputs: Common_Countmore1001Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`99+`)
};

/**
* | output |
* | --- |
* | "99+" |
*
* @param {Common_Countmore1001Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_countmore1001 = /** @type {((inputs?: Common_Countmore1001Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Countmore1001Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_countmore1001(inputs)
});
export { common_countmore1001 as "common_countMore100" }